export default [
    //FOR Adjustment Manager==========================================================================
    {
        key: "New Adjustments",
        status: "New Adjustments",
        label: "This Adjustments is not Subbmited Yet",
        reject_reason: "",
        actionButtons: [
            {
                endPoint: "updateAdjustmentStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "Submitted HOD",
                },

                getReason: false,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "",
                rejectReasonMessage: "Why Are you Rejecting this Adjustments?",

                buttonLabel: "Submit To HOD",
                color: 'success',
                icon: "icon-send",
                btnSize: "large",

                confirmationTitle: "Submission",
                confirmationMessage: "Are you sure you want to submit this to your HOD?",
                successMessage: "This Adjustments has been successfully Submitted to HOD",

                sucessEventName: "changeView",
                successEventValue: "list",
            },

        ]

    },
    {
        key: "View Pending Adjustment",
        status: "Submitted HOD",
        label: "This Adjustment is waiting for Approval by your HOD",
        reject_reason: "",
        actionButtons: [

        ]
    },
   
     
    
    {
        key: "View Approved Adjustment",
        status: "Approved Adjustment",
        label: "This Adjustment has been Approved.",
        reject_reason: "",
        actionButtons: [

        ]
    },
    
    {
        key: "View Rejected Adjustment",
        status: "Rejected Adjustment",
        label: "This Adjustment has been Rejected.",
        rejectReason: "",
        actionButtons: [

        ]
    },
   
    //------------------------------------------------------------------------------------------
    
    //FOR Adjustment Approver==================================================================
    {
        key: "HOD Pending Approval",
        status: "Submitted HOD",
        label: "Evaluate this Adjustment and Approve or Reject it.",
        reject_reason: "",
        actionButtons: [
            {
                endPoint: "updateAdjustmentStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "Approved Adjustment",
                },

                getReason: false,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "",
                rejectReasonMessage: "",

                buttonLabel: "Approve",
                color: 'success',
                icon: "icon-thumbs-up",
                btnSize: "large",

                confirmationTitle: "Submission",
                confirmationMessage: "Are you sure you want to Approved this Adjustment?",
                successMessage: "This Adjustment has been successfully Approved.",

                sucessEventName: "changeView",
                successEventValue: "list",
            },
            {
                endPoint: "updateAdjustmentStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "Rejected Adjustment",
                },

                getReason: true,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "Reject Confirmation",
                rejectReasonMessage: "Why Are you Rejecting this Adjustment?",

                buttonLabel: "Reject",
                color: 'danger',
                icon: "icon-thumbs-down",
                btnSize: "large",

                confirmationTitle: "Rejection",
                confirmationMessage: "",
                successMessage: "This Adjustment has been successfully Rejected",

                sucessEventName: "changeView",
                successEventValue: "list",
            }

        ]

    },    
    {
        key: "Approved Adjustment",
        status: "Approved Adjustment",
        label: "This Adjustment has been Approved.",
        reject_reason: "",
        actionButtons: [

        ]
    },
   
    {
        key: "Rejected Adjustment",
        status: "Rejected Adjustment",
        label: "This Adjustment has been rejected.",
        rejectReason: "",
        actionButtons: [

        ]
    },
   

      
    //------------------------------------------------------------------------------------------
]